import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const ShoppingCartIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M7.5 17.25C7.77614 17.25 8 17.0261 8 16.75C8 16.4739 7.77614 16.25 7.5 16.25C7.22386 16.25 7 16.4739 7 16.75C7 17.0261 7.22386 17.25 7.5 17.25Z"
                fill={props.htmlColor ?? '#21272E'}
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.5 17.25C15.7761 17.25 16 17.0261 16 16.75C16 16.4739 15.7761 16.25 15.5 16.25C15.2239 16.25 15 16.4739 15 16.75C15 17.0261 15.2239 17.25 15.5 17.25Z"
                fill={props.htmlColor ?? '#21272E'}
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2 2.75H4.90909L6.85818 12.5691C6.92469 12.9067 7.10684 13.21 7.37276 13.4258C7.63868 13.6417 7.97142 13.7563 8.31273 13.7497H15.3818C15.7231 13.7563 16.0559 13.6417 16.3218 13.4258C16.5877 13.21 16.7699 12.9067 16.8364 12.5691L18 6.41658H5.63636"
                stroke={props.htmlColor ?? '#21272E'}
                fill="none"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
